import {
  CarOutlined,
  FilePdfOutlined,
  PrinterOutlined,
} from '@ant-design/icons';
import styled, { useTheme } from 'styled-components';

import { Button, Flex, Typography } from '../../../designComponents';
import { ContainerStyled } from './styled';

export const WhatYouGetStyled = styled.section`
  padding: 80px 0;
`;

export const FeatureCardStyled = styled.div`
  flex: 1 1 250px;
  max-width: 300px;
  background: ${({ theme }) => theme.colors.white};
  padding: 30px;
  border-radius: 20px;
  text-align: center;

  .feature-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 15px;
    font-size: 40px; /* controls the icon size */
    color: ${({ theme }) => theme.colors.primary};
  }
`;

const WhatYouGet = () => {
  const theme = useTheme();

  const features = [
    {
      icon: (
        <FilePdfOutlined
          style={{ fontSize: '40px', color: theme.colors.primary }}
        />
      ),
      title: 'Print-ready PDF',
      description:
        'Clear exits, routes & assembly points, suitable for wall mounting, accepted by inspectors & insurers',
    },
    {
      icon: (
        <PrinterOutlined
          style={{ fontSize: '40px', color: theme.colors.primary }}
        />
      ),
      title: 'We print for you',
      description:
        'A4 / A3, Laminated or rigid board, printed to professional standards',
    },
    {
      icon: (
        <CarOutlined
          style={{ fontSize: '40px', color: theme.colors.primary }}
        />
      ),
      title: 'Posted directly to your site',
      description:
        'Fast and secure delivery so your plans are on-site when you need them',
    },
  ];

  return (
    <WhatYouGetStyled>
      <ContainerStyled>
        <Typography
          variant="heading"
          strong
          style={{
            textAlign: 'center',
            marginBottom: '50px',
            color: theme.colors.primary,
          }}
        >
          What You Get
        </Typography>

        <Flex gap="30px" justifyContent="space-between" wrap="wrap">
          {features.map((feature, idx) => (
            <FeatureCardStyled key={idx}>
              <div className="feature-icon">{feature.icon}</div>
              <Typography
                variant="title"
                strong
                style={{ margin: '15px 0 10px' }}
              >
                {feature.title}
              </Typography>
              <Typography>{feature.description}</Typography>
            </FeatureCardStyled>
          ))}
        </Flex>

        <Flex justifyContent="center" style={{ marginTop: '50px' }}>
          <Button style={{ borderRadius: '28px', padding: '12px 24px' }}>
            Upload Your Plans & Get Started
          </Button>
        </Flex>
      </ContainerStyled>
    </WhatYouGetStyled>
  );
};

export default WhatYouGet;
